import gql from "graphql-tag";

export const REPORT_DETAIL_SECRET_QUERY = gql`
  query ReportDetailSecretView($secret: String!) {
    reportSecret(secret: $secret) {
      id
      ownerCompany
      dataValidation
      secret
      name
      report_number
      created_at
      order_confirmation
      shipping_date
      order_date
      customer_order_number
      availablePdfLayouts
      step
      customer
      manufacturer
      production_plant
      updated_at
      signatureUrl
      recordedBy
      doneBySupervisor
      work_order_nr
      attachments {
        uuid
        url
      }

      sheets {
        id
        dataValidation
        material_certificate
        heat_nr
        charge
        orderQuantity
        template {
          id
          name
        }
        attachments {
          uuid
          url
        }
        info {
          woodNr
          insertionDirection
          woodMoisture
          woodDensity
          roomTemperature
          roomMoisture
        }
        rtor_mw
        rtor_k1
        rtor_k2
        ftor_k1
        my_k1
        fax_k1
        fhead_k1
        ftens_k1
        tor_rat_1
        tor_rat_2
        tor_rat_3
        product {
          id
          technicalDrawing
          description
          articleNumber
          customer
          screwType
          head
          screwDiameter
          screwLength
          recessType
          surfaceColor
          threadType
          drawing1Url
          drawing2Url
          drawing3Url
          productGroup {
            id
            name
          }
          properties {
            stringValue {
              id
              propertyType
              value
            }
            singleValue {
              id
              propertyType
              name
            }
            multpileValues {
              propertyType
              id
              values {
                id
                propertyType
                name
              }
            }
          }
        }
        characteristicGroups {
          characteristics {
            id
            shortcut
            dataType
            isCritical
            translations {
              de
              en
              zh
            }
            measurements {
              value
            }
            unit {
              name
            }
            unitTranslations {
              de
              en
              zh
            }
            minDiff
            maxDiff
            value1
            value2
            order
          }
        }
      }
    }
  }
`;
